import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createContext, useEffect, useState } from 'react';
import { getUserTrackingIntent } from "./utils";
import { jsx as _jsx } from "react/jsx-runtime";
export var TrackingContext = /*#__PURE__*/createContext(undefined);
export var TrackingProvider = function TrackingProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    intent = _useState2[0],
    _setIntent = _useState2[1];
  var clearIntent = function clearIntent() {
    _setIntent(null);
  };

  // Read the query params on the first page render
  useEffect(function () {
    var userIntent = getUserTrackingIntent();
    if (userIntent) {
      _setIntent(userIntent);
    }
  }, []);
  return /*#__PURE__*/_jsx(TrackingContext.Provider, {
    value: {
      // We expose this formatted data to make it easier to send it to the backend
      formattedIntent: intent ? {
        upperFunnelJobToBeDone: intent.jobToBeDone,
        upperFunnelSource: intent.source,
        upperFunnelUrlSource: intent.urlSource
      } : {},
      setIntent: function setIntent(_intent) {
        _setIntent(_objectSpread(_objectSpread({}, _intent), {}, {
          urlSource: window.location.href
        }));
      },
      clearIntent: clearIntent
    },
    children: children
  });
};